import {Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {PassOnLog, PassOnLogInterface, PassOnLogReaderInterface} from '../types/data.types';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {ConstantsService} from './constants.service';
import {AccountPermissionsService} from './account-permissions.service';
import {Subject} from 'rxjs/Subject';
import {PassOnLogApiService} from './api/pass-on-log-api.service';
import {AuthApiService} from './api/auth-api.service';
import {IPassOnLogSettings} from '../types/api-response/pass-on-log-settings';
import {IPropertyManagerRole} from '../types/api-response/auth/roles';
import {map, take} from 'rxjs/operators';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {AuthenticationService} from './authentication.service';

declare const toastr: any;
declare const swal: any;
declare const $: any;

@Injectable()
export class PassOnLogService {
    showDetailedView = false;
    isPassOnLogModalShow = false;
    isViewPassOnLogModalShow = false;
    isPassOnLogHistoryModalShow = false;
    isPassOnLogStatusHistoryModalShow = false;

    selectedItemData: PassOnLog;

    passOnLogInPassOnLogModal: PassOnLog;
    passOnLogInHistoryModal: PassOnLog;

    data = {
        allPassOnLogs: {
            get: '/v1/pass_on_log.json?expand=building,suite,resident,createdBy,readers',
            data: [],
            total: null
        },
    };
    tabId = 'passOnLog';
    spinnerShow = false;
    showServiceUnavailable = false;
    buildings:    Array<any> = [];
    buildingsForRead: Array<any> = [];
    buildingsForUpdate: Array<any> = [];
    serviceName: string = 'pass_on_log';

    constructor(
        public api: ApiClientService,
        private passOnLogApi: PassOnLogApiService,
        private authApi: AuthApiService,
        public urlService: UrlService,
        public emptyRowService: EmptyRowService,
        public account: AccountPermissionsService,
        private authenticationService: AuthenticationService
    ) {
        this.api.onLogout.subscribe(() => {
            this.buildings = [];
        });
    }

    getData() {
        this.showServiceUnavailable = false;
        this.spinnerShow = true;
        this.data[this.tabId].total = null;

        const tabId       = this.urlService.queryParams['tab'];
        const url         = '/v1/pass_on_log.json?expand=building,suite,resident,createdBy,readers';
        const queryParams = this.urlService.getQueryParamsString();

        this.api.get('domainPassOnLog', `${url}${queryParams}`).subscribe(
            (res) => {
                const body = JSON.parse(res._body);
                const entities = body.entities;
                this.data[tabId].data = [];
                this.data[tabId].total = body.total;
                this.emptyRowService.fillEmptyRow();
                entities.map(item => {
                    if (item.building && item.building.bdId) return item.building.id = item.building.bdId;
                });
                this.account.addEntitiesPermissions(entities, this.serviceName);
                this.passOnLogFactory(entities, this.data[tabId].data);
                if (this.selectedItemData) {
                    this.selectedItemData = this.data.allPassOnLogs.data.find(si => si.id == this.selectedItemData.id);
                    if(this.selectedItemData)
                        this.selectedItemData.checked = true;
                    else
                        this.showDetailedView = false;
                }
                this.spinnerShow = false;
                if($('.table')[0])
                    $('.table')[0].scrollIntoView();
            },
            (error) => {
                this.showServiceUnavailable = true;
                this.spinnerShow = false;
                this.api.errorHandler(error, 'Failed get Pass On Log');
            }
        );
    }

    passOnLogFactory(entities: any, targetArray) {
        entities.forEach((pass) => {
            const passOnLog = new PassOnLog();

            if (pass.passOnLogNumber     ) passOnLog.passOnLogNumber      = pass.passOnLogNumber;
            if (pass.building            ) passOnLog.buildingId           = +pass.building.bdId;
            if (pass.building            ) passOnLog.buildingName         = pass.building.name;
            if (pass.id                  ) passOnLog.id                   = +pass.id;
            if (pass.subject             ) passOnLog.subject              = pass.subject;
            if (pass.announcement        ) passOnLog.announcement         = pass.announcement;
            if (pass.startDate           ) passOnLog.startDate            = pass.startDate;
            if (pass.endDate             ) passOnLog.endDate              = pass.endDate;
            if (pass.status              ) passOnLog.status               = pass.status;
            if (pass.markAsRead          ) passOnLog.markAsRead           = pass.markAsRead;
            if (pass.readers             ) passOnLog.readers              = pass.readers;
            if (pass.createdBy           ) passOnLog.createdBy            = pass.createdBy;
            if (pass.createdAt           ) passOnLog.createdAt            = pass.createdAt;
            passOnLog.isCanEdit = pass.isCanEdit;
            passOnLog.isCanDelete = pass.isCanDelete;

            targetArray.push(passOnLog);
        });
    }

    getBuildings(): void {
        if (this.buildings.length) return;
        const url = `/v1/buildings/short.json?per-page=10000&order-by=name|asc`;
        this.api.get('domainBD', url).subscribe(
            (res)   => {
                this.buildings = JSON.parse(res._body).entities;
                this.getFilteredBuildings();
            },
            (error) => this.api.errorHandler(error, 'Failed get buildings')
        );
    }

    resetData() {
        for (const item in this.data) {
            this.data[item].data = [];
            this.data[item].total = null;
        }
    }

    deletePassOnLog(passOnLog: PassOnLog): void {
        let minusPage = 0;
        if (this.data.allPassOnLogs.total % this.urlService.queryParams['per-page'] == 1)
            minusPage = this.urlService.queryParams['page'] - 1;
        if (!passOnLog.id) return;
        swal(ConstantsService.getSwalConfig('Delete Pass On Log'),
            () => {
                const url = `/v1/pass_on_log/${passOnLog.id}.json`;
                this.api.remove('domainPassOnLog', url).subscribe(
                    () => {
                        toastr.success('Pass On Log has been deleted.');
                        if (minusPage) {
                            this.urlService.queryParams['page'] = minusPage;
                            this.urlService.setQueryParams('allPassOnLogs', minusPage);
                        }
                        this.getData();
                    },
                    (error) => this.api.errorHandler(error, 'Delete Pass On Log failed')
                );
            }
        );
    }

    viewPassOnLog(passOnLog: PassOnLog): void {
        this.isViewPassOnLogModalShow = true;
        this.passOnLogInPassOnLogModal = Object.assign({}, passOnLog);
    }

    editPassOnLog(passOnLog: PassOnLog): void {
        this.isPassOnLogModalShow = true;
        this.passOnLogInPassOnLogModal = Object.assign({}, passOnLog);
    }

    canEdit(buildingId?: number) {
        return this.account.canUpdate(this.serviceName, buildingId);
    }

    canDelete(buildingId?: number) {
        return this.account.canDelete(this.serviceName, buildingId);
    }

    getFilteredBuildings() {
        this.buildingsForRead =  this.account.getBuildingsForRead(this.buildings, this.serviceName);
        this.buildingsForUpdate = this.account.getBuildingsForUpdate(this.buildings, this.serviceName);
    }

    readPassOnLog(item: PassOnLogInterface, status: boolean) {
        const subjectResult: Subject<PassOnLogInterface> = new Subject();

        if(!item.markAsRead) {
            this.api.post('domainPassOnLog', `/v1/pass_on_log_read.json`, {passOnLog: item.id}).subscribe(
              (res: PassOnLogReaderInterface) => {
                  toastr.success('Successfully changed the read status');
                  item.markAsRead = res;
                  item.readers.push(res);
                  subjectResult.next(item);
                  subjectResult.complete();
              },
              error => {
                  this.api.errorHandler(error, 'Changing read status failed');
                  subjectResult.error(error);
              }
            );
        } else {
            this.api.patch('domainPassOnLog', `/v1/pass_on_log_read/${item.markAsRead.id}.json`, {enable: status}).subscribe(
              (res: PassOnLogReaderInterface) => {
                    toastr.success('Successfully changed the read status');
                    item.markAsRead = res;
                    item.readers.forEach(reader => {
                        if(reader.id == res.id) {
                            reader.enable = res.enable;
                        }
                    });
                    subjectResult.next(item);
                    subjectResult.complete();
                }, error => {
                  this.api.errorHandler(error, 'Changing read status failed');
                  subjectResult.error(error);
              }
            );
        }

        return subjectResult.asObservable();
    }

    toggleDetailedView(data, state: boolean = false): void {
        if(!data)
            this.data.allPassOnLogs.data.forEach(item => item.checked = false);
        this.selectedItemData = data ? data : null;
        this.showDetailedView = state;
        if (this.selectedItemData) {
            this.showDetailedView = true;
            for (const field in this.selectedItemData.formFields)
                this.selectedItemData.formFields[field].editMode = false;
        }
    }

    /**
     * Checks permissions to show pass on log popups
     * on dashboard page
     */
    public checkPopupShowPermissions(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            const settings$ = this.passOnLogApi.getSettings().pipe(
              take(1),
              map(result => result.entities)
            );

            const roles$ = this.authApi.getMyRoles(this.authenticationService.user$);

            let isShow = false;
            forkJoin([roles$, settings$]).subscribe(([roles, settings]) => {
                const roleIds = (roles as IPropertyManagerRole[]).map(role => role.id);
                isShow = !settings.length; // show popup if empty settings

                for(const item of (settings as IPassOnLogSettings[])) {
                    if(item.showPopupUponDashboard.active) {
                        // roles of the current user that intersecting with roles of settings
                        const userFilteredRoles = item.showPopupUponDashboard.roles.filter(role => roleIds.includes(role.bdId));
                        isShow = isShow || !item.showPopupUponDashboard.roles.length || !!userFilteredRoles.length;
                    }

                    if(isShow) {
                        break;
                    }
                }

                resolve(isShow);
            }, error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/pass-on-log.service.ts